import { createReactExtension } from '@backstage/core-plugin-api';
import { homePlugin } from '@backstage/plugin-home';

export const EmptyWidgetComponent = () => <></>;

// Note: This component is intentionally left empty.
// To have it as a default placeholder on the homepage to not show any content/headline as it otherwise would be.
export const EmptyWidget = homePlugin.provide(
  createReactExtension({
    name: 'EmptyWidget',
    component: {
      lazy: () => import('./empty-widget').then(m => m.EmptyWidgetComponent),
    },
    data: {
      'home.widget.config': {
        layout: {
          title: 'Empty Widget',
          description: 'This widget is left intentionally blank.',
          height: { maxRows: 1 },
          layout: {
            height: { minRows: 1 },
            width: { minColumns: 12 },
          },
        },
      },
    },
  }),
);
